/*
 * types/services/dr2am.tasks.preferences.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbPreference} from './PbPreference';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceCreatePreferenceResponse model module.
 * @module model/ServiceCreatePreferenceResponse
 * @version version not set
 */
export class ServiceCreatePreferenceResponse {
  /**
   * Constructs a new <code>ServiceCreatePreferenceResponse</code>.
   * @alias module:model/ServiceCreatePreferenceResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceCreatePreferenceResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceCreatePreferenceResponse} obj Optional instance to populate.
   * @return {module:model/ServiceCreatePreferenceResponse} The populated <code>ServiceCreatePreferenceResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceCreatePreferenceResponse();
      if (data.hasOwnProperty('preference'))
        obj.preference = PbPreference.constructFromObject(data['preference']);
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbPreference} preference
 */
ServiceCreatePreferenceResponse.prototype.preference = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceCreatePreferenceResponse.prototype.state = undefined;


